import { Directive } from '@angular/core';
import { Validator, NG_VALIDATORS, AbstractControl } from '@angular/forms';
import { StringUtilities } from '../../../core-utilities/String.utility';

@Directive({
    selector: '[validateEmail][ngModel],[validateEmail][formControl]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: EmailValidatorDirective,
            multi: true
        }
    ],
    standalone: false
})
export class EmailValidatorDirective implements Validator {
    validate(c: AbstractControl) {
        return EmailValidatorDirective.emailValidation(c);
    }

    static emailValidation(c: AbstractControl) {
        return StringUtilities.rawEmailValidation(c.value)
            ? null
            : {
                  validateEmail: {
                      valid: false
                  }
              };
    }
}
